import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function DepositFillIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M8 13a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3zm-1.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M15 18.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M8 2a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zM6.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M19 2a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm-1.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" />
    </Icon>
  );
}

DepositFillIcon.displayName = 'DepositFillIcon';
